var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWheelchairWheels(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32,6.57c-14.21,0-25.76,11.56-25.76,25.76s11.56,25.76,25.76,25.76,25.76-11.56,25.76-25.76S46.21,6.57,32,6.57Zm3.18,20.55c-.52-.32-1.08-.56-1.68-.71V9.63c5.17,.34,9.87,2.41,13.54,5.64l-11.85,11.85Zm-4.68-.71c-.56,.14-1.09,.36-1.57,.64l-11.87-11.87c3.65-3.18,8.31-5.22,13.44-5.56V26.41Zm-1.57,11.21c.49,.28,1.01,.5,1.57,.64v16.78c-5.13-.34-9.79-2.37-13.44-5.56l11.87-11.87Zm4.57,.64c.6-.15,1.17-.39,1.68-.71l11.85,11.85c-3.66,3.23-8.36,5.3-13.54,5.64v-16.78Zm3.78-2.85c.29-.5,.52-1.05,.66-1.64h16.77c-.32,5.15-2.37,9.84-5.56,13.5l-11.87-11.87Zm.63-4.64c-.14-.54-.35-1.04-.63-1.51l11.87-11.87c3.17,3.63,5.2,8.28,5.55,13.38h-16.79ZM14.93,17.3l11.85,11.85c-.3,.5-.54,1.04-.69,1.62H9.3c.35-5.15,2.42-9.83,5.63-13.47Zm-5.64,16.47H26.06c.15,.63,.4,1.21,.72,1.74l-11.85,11.85c-3.24-3.68-5.32-8.4-5.64-13.6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelchairWheels);
export default __webpack_public_path__ + "static/media/wheelchair_wheels.e26b76a4.svg";
export { ForwardRef as ReactComponent };